(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.retail-tabs-menu button');
  const tabContents = document.querySelectorAll('.retail-grid[data-tab-panel]');

  function isMobile() {
    return window.innerWidth <= 767;
  }

  tabButtons.forEach(function (btn, idx) {
    btn.addEventListener('click', function () {
      if (isMobile()) {
        btn.classList.toggle('active');
        if (tabContents[idx].style.display === 'grid') {
          tabContents[idx].style.display = 'none';
        } else {
          tabContents[idx].style.display = 'grid';
        }
      } else {
        tabButtons.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.style.display = 'none');
        btn.classList.add('active');
        tabContents[idx].style.display = 'grid';
      }
    });
  });

  if (!isMobile() && tabButtons[0]) {
    tabButtons[0].classList.add('active');
    tabContents[0].style.display = 'grid';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const accordionButtons = document.querySelectorAll('.accordion-btn');
  const accordionPanels = document.querySelectorAll('.accordion-panel');

  accordionButtons.forEach((btn, idx) => {
    btn.addEventListener('click', function () {
      const isOpen = accordionPanels[idx].style.display === 'block';
      accordionPanels.forEach(panel => panel.style.display = 'none');
      accordionButtons.forEach(b => b.classList.remove('active'));
      if (!isOpen) {
        accordionPanels[idx].style.display = 'block';
        btn.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var flickityElement = document.querySelector('.js-flickity');
  var flickityInstance = new Flickity(flickityElement, {
    wrapAround: true,
    pageDots: false
  });

  document.querySelectorAll('.stl-hotspot').forEach(hotspot => {
    hotspot.addEventListener('click', () => {
      const index = parseInt(hotspot.getAttribute('data-index'));
      flickityInstance.select(index);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-detail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gallery-slider]').forEach(function (root) {
    var viewport = root.querySelector('.store-detail-gallery-viewport');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (!viewport || !prevBtn || !nextBtn) return;

    function step() {
      var cell = viewport.querySelector('.store-detail-gallery-cell');
      var gap = 20;
      if (!cell) return viewport.clientWidth;
      return cell.getBoundingClientRect().width + gap;
    }

    prevBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
